<template>
  <vue-scroll :ops="ops" ref="vs"  @handle-scroll="handleScroll">
    <div class="info">
      <first-Component  class="header" :class="{active:!isShowNav}"  style="position: absolute;top:0;z-index: 999;background-color: white;" :num=3 ></first-Component>

      <first-Component class="animated bounceInDown" style="position: fixed;
    z-index: 999999;
    background-color: white;animation-duration:3s;" :num=3 v-if="!isShowNav"></first-Component>
      <div class="main" id="d1">
       <div class="one">
         <div class="banner">
           <el-carousel height="400px"   arrow="always">
             <el-carousel-item v-for="(item,index) in imgPath" :key="index">
               <img class="bigImg animated  zoomIn"   style="width:100%;height:100%;cursor: pointer;object-fit: contain"  :src="`http://www.nbbinyu.com/upload/${item.PICURL}`" @click="getSrc(item.PICURL)">
             </el-carousel-item>
           </el-carousel>
         </div>
         <div class="right ">
           <span class="btn" @click="go" style="z-index: 10000">{{$t('back')}}</span>
           <a :href="proInfo.URL" target="_blank" v-if="proInfo.URL!==''">
<!--             <span class="buy"  style="z-index: 10000">{{$t('buy')}}</span>-->
             <img src="../assets/ya.svg" alt="" >
             <img src="../assets/ym2.svg" >
           </a>
           <p class="a animated jello ">{{proInfo.PRONAME}}</p>
           <p class="b">{{proInfo.TITLE2}}</p>
           <div class="c" v-html="proInfo.MEMO"></div>
         </div>
          <p class="t">{{$t('proInfoTitle')}}</p>
         <p class="content" v-html="proInfo.CONTENT">
         </p>

       </div>

      </div>
      <foot-Component @gotoTop="gotoTop"></foot-Component>
    </div>
    <div class="im" @click="hide" id="d2" :class="{'imClass':noStyle}" >
      <img :src="src" alt="" >
    </div>
  </vue-scroll>
</template>

<script>
  import firstComponent from './first'
  import footComponent from './foot'
  import {getProductsInfo} from '../util/lang'
    export default {
        name: "productInfo",
      data(){
          return{
            noStyle:false,
            src:'',
            proInfo:{},
            isShowNav:true,
            imgPath:[],
            ops: {
              vuescroll: {
                mode: 'native',
                sizeStrategy: 'percent',
                detectResize: true
              },
              scrollPanel: {
                speed: 300,
                scrollingX: false,
              },
              rail: {
                background: '#01a99a',
                opacity: 0,
                size:'2px'
              },
              bar: {
                showDelay: 500,
                background: '#0C3665',
                size: '2px',
              }
            },
          }
      },
      components:{firstComponent,footComponent},
      mounted(){
       let id=this.$route.query.id
        this.getInfo(id)
      },
      methods:{
        hide(){
          this.noStyle=false
        },
        getSrc(n){
          this.noStyle=true
          setTimeout(()=>{
            this.$refs['vs'].scrollIntoView('#d2', 500);
          },100)
          this.src="http://www.nbbinyu.com/upload/"+n
        },
        gotoTop(){
          this.$refs['vs'].scrollIntoView('#d1', 500);
        },
          getInfo(id){
            this.$nextTick(()=>{
              const url = `${getProductsInfo( this.$i18n.locale,id)}`
              this.$axios.get(url).then(res => {
                this.proInfo=res.data.proarr
                this.imgPath=res.data.proimg
                console.log(this.proInfo)
              })
            })
          },
        handleScroll(vertical, horizontal, nativeEvent) {
          let top=vertical.scrollTop
          if(top>0){
            this.isShowNav=false
          }else{
            this.isShowNav=true
          }
          window.pageYOffset=top
        },
          go(){
            this.$router.back(-1)
          }
      }
    }
</script>

<style lang="scss" scoped>
  .header{
    transition: 1s;
    &.active{
      transform: translateY(-100%);
    }
  }
.main{
  width:100%;
   background-color: #FAFAFA;
  padding-top: 160px;
  padding-bottom: 120px;
  position: relative;

  .one{
    width:1280px;
    margin: 0 auto;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    .banner{
      width:50%;
    }
    .right{
      width:47%;
      padding-left: 3%;
      position: relative;
      .btn{
        font-weight: bold;
        display: inline-block;
        color:#C7000C;
        padding: 8px 8%;
        font-size: 12px;
        border: 1px solid #0C3665;
        -webkit-border-radius: 60px / 50px;
        -moz-border-radius: 60px / 50px;
        border-radius: 60px / 60px;
        cursor: pointer;
        background: linear-gradient(top, #0C3665,#0C3665) no-repeat;
        background-size: 100% 0%;
        text-transform: uppercase;
        -webkit-transition: all .5s;
        transition: all .5s;
        position: absolute;
        right:0;
      }
      .btn:hover{
        background-size: 100% 100%;
        color: white;
      }
      a{
        position: absolute;
        top:30%;
        left:50%;
        background: linear-gradient(top, #0C3665,#0C3665) no-repeat;
        background-size: 100% 0%;
        border: 1px solid #0C3665;
        border-radius: 20px;
        text-transform: uppercase;
        -webkit-transition: all .5s;
        transition: all .5s;
        padding: 0px 25px;
        padding-top: 5px;
        img{
          height:22px;
          width:60px;
        }
        img:nth-child(1){
          opacity: 1;
          transition: all .5s;
        }
        img:nth-child(2){
          opacity: 0;
          transition: all 1s;
          display: none;
        }
      }
      a:hover{
          background-size: 100% 100%;
        img:nth-child(1){
          opacity: 0;
          display: none;
        }
        img:nth-child(2){
          opacity: 1;
          display: inline-block;
          transform: scale(1.1);
        }
      }
      .a{
        font-size: 25px;
        color:#0C3665;
        font-weight: bold;
      }
      .b{
        font-size: 14px;
        color:#9F9F9F;
        font-family: light;
      }
      .c{
        width:85%;
        line-height: 40px;
        font-family: light;
      }
    }
    .t{
      text-align: left;
      width:1280px;
      font-size: 30px;
      margin: 40px auto;
      color:#0C3665;
    }
    .content{
      width:100%;
      line-height: 35px;
      font-family: light;
      margin-top: 0px;
    }
    .de{
      margin: 60px auto;
      img{
        transition: all 1s;
        cursor: pointer;
      }
      img:hover{
        transform: scale(1.1);
      }
    }
  }
  @media screen and (max-width:768px){
    .one{
      width:90%;
      padding-left: 5%;
    }
  }
  @media screen and (max-width:450px){
    .one{
      display: flex;
      flex-direction: column;
      .banner{
        width:95%;
      }
      .right{
        width:95%;
        padding-left: 0;
        .btn{
          top:20px;
          right:2%;
        }
      }
    }

  }
}
  .im{
    width:100%;
    height:100%;
    background-color: rgba(0,0,0,.8);
    position: absolute;
    top:0;
    left:-100%;
    z-index: 10000;
    text-align: center;
    transition: all 1s;
    img{
      width:800px;
      height:800px;
      object-fit: contain;
      margin-top: 100px;
    }
  }
  .imClass{
    left:0;
  }
  @media screen and (max-width:1366px){
    .im{
      img{
        height:600px;
        width:600px;
      }
    }
  }
  @media screen and (max-width:450px){
    .im{
      img{
        width:80%;
        margin-top:50px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/productInfo.vue